import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-timeframe-picker',
  templateUrl: './formly-timeframe-picker.component.html',
  styleUrls: [],
})
export class FormlyTimeframePickerComponent extends FieldType {
  blurHandler(event) {
    this.formControl.markAllAsTouched()
  }
}
